import { SubEvent } from 'sub-events/dist/src/event';
export class ActionRequest {
    constructor(id, action, device = null) {
        this.id = id;
        this.action = action;
        this.device = device;
        if (device != null) {
            this.type = 'DEVICE_REQUEST';
        }
        else {
            this.type = 'GENERAL_REQUEST';
        }
    }
}
export class NWLVersionRequest {
    constructor() {
        this.type = 'NWL_VERSION';
    }
}
export class LogRequest {
    constructor(logLevel, message) {
        this.type = 'LOG';
        this.level = logLevel;
        this.message = message;
    }
}
export class CommunicationService {
    constructor() {
        this.eventReceivedEvent = new SubEvent();
        this.connectedToAppEvent = new SubEvent();
        this.disconnecedFromAppEvent = new SubEvent();
        this.errorEvent = new SubEvent();
        this.requestSendTimeout = 1000;
        this.isConnectedField = false;
        this.requestId = 1;
        this.requestArray = [];
    }
    get isConnected() {
        return this.isConnectedField;
    }
    set isConnected(value) {
        if (this.isConnectedField !== value) {
            this.isConnectedField = value;
            if (value) {
                this.connectedToAppEvent.emit(null);
            }
            else {
                this.disconnecedFromAppEvent.emit(null);
            }
        }
    }
    processMessage(response) {
        const type = response.type != null ? response.type.toUpperCase() : null;
        switch (type) {
            case 'EVENT': {
                this.eventReceivedEvent.emit(response);
                break;
            }
            case 'ACTION': {
                this.processActionResponse(response.id, response.action);
                break;
            }
            case 'NWL_VERSION': {
                this.nwlVersion = response.version;
                break;
            }
            default: {
                throw new Error(`Unknown type in response: ${JSON.stringify(response)}`);
            }
        }
    }
    processActionResponse(id, response) {
        const request = this.getRequestWithId(id);
        if (request == null) {
            this.logger.error(`No matching request found for response: ${JSON.stringify(response)} with id`, id);
            return;
        }
        if (response.success) {
            request.resolve(response);
        }
        else {
            request.reject(response);
        }
    }
    getRequestWithId(id) {
        return this.requestArray.find((element) => element.id === id);
    }
    removeRequestWithId(id) {
        const request = this.requestArray.find((element) => element.id === id);
        const index = this.requestArray.indexOf(request, 0);
        if (index > -1) {
            this.requestArray.splice(index, 1);
        }
    }
    createPromise(request) {
        let outsideResolve;
        let outsideReject;
        const promise = new Promise((resolve, reject) => {
            outsideResolve = resolve;
            outsideReject = reject;
        });
        this.requestArray.push({
            id: request.id,
            resolve: outsideResolve,
            reject: outsideReject,
        });
        return promise;
    }
}
//# sourceMappingURL=data:application/json;base64,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